<!-- <div class="timeline-container">
    <div class="timeline-arrow">
        <div *ngFor="let step of steps; let i = index" class="step-container">
            <div *ngIf="!step.skipped" class="step" [class.arrow-approved]="step.step_status === 'approved'"
                [class.active]="activeIndexCode === step.code" [class.completed]="isStepCompleted(step)"
                (click)="onActiveIndexChange(step)">

                <div class="step-indicator">
                    <span class="step-number">{{ getStepNumber(step) }}</span>
                </div>
                <span class="step-label">{{ step.name }}</span>

                <div class="step-arrow" *ngIf="i < steps.length - 1"></div>
            </div>
        </div>
    </div>
</div> -->


<!-- <div class="page-header">
    <div class="header-content">
        <div class="scheme-info">
            <h2 class="scheme-name">{{ schemeName }}</h2>
            <div class="proposal-info">
                <span class="proposal-label">Proposal:</span>
                <span class="proposal-name">{{ proposalName }}</span>
            </div>
        </div>
          
    </div>
</div> -->

<div class="d-flex justify-content-between gap-2 mb-3">
  <button
    *ngFor="let tab of tabList; let i = index"
    class="nav-tab btn flex-fill"
    [ngClass]="['tab-' + i, activeTabIndex === i ? 'active' : '']"
    (click)="onTabChange({ index: i })"
  >
    {{ tab.name }}
  </button>
</div>

<div class="card p-3 shadow-sm">

    <!-- ================= Timeline Stepper ================= -->
    <div class="d-flex align-items-center justify-content-between mb-4">
        <!-- Left Arrow -->
        <button class="btn btn-outline-primary prev-btn" (click)="navigate(-1)" [disabled]="currentIndex === 0">
            ‹ Prev
        </button>

        <!-- Timeline -->
		<div class="flex-grow-1 mx-3 overflow-auto">
			<div class="d-flex align-items-center timeline-stepper">
				<ng-container *ngFor="let step of visibleSteps; let i = index">
					<!-- Step Item -->
					<div class="timeline-stepper-item text-center me-3">
						<div class="timeline-stepper-circle cursor-pointer" [class.timeline-stepper-current]="isCurrent(step)"
							[class.timeline-stepper-approved]="step.step_status === 'approved'"
							(click)="onActiveIndexChange(step)">
							<span *ngIf="step.step_status === 'approved'">✔</span>
							<span *ngIf="step.step_status !== 'approved'">{{ getStepNumber(step) }}</span>
						</div>
						<div class="timeline-stepper-label small" [class.active-font-size]="isCurrent(step)">
							{{ step.name }}
						</div>
					</div>
		
					<!-- Connector -->
					<div *ngIf="i < visibleSteps.length - 1" class="timeline-stepper-connector"
						[class.timeline-stepper-connector-completed]="isStepCompleted(step)"></div>
				</ng-container>
			</div>
		</div>

        <!-- Right Arrow -->
        <button class="btn btn-outline-primary next-btn" (click)="navigate(1)"
            [disabled]="currentIndex >= filteredSteps.length - 1">
            Next ›
        </button>
    </div>

    <hr>

    <!-- ================= Collapsible Route Config ================= -->
  <div class="mb-4">
		<!-- Single Toggle Button -->
		<div class="d-flex justify-content-start w-100">
			<button class="btn btn-primary w-100" (click)="routeConfigExpanded = !routeConfigExpanded">
				{{ routeConfigExpanded ? 'Hide Route Configuration' : 'Route Configuration' }}
			</button>
		</div>
	
		<!-- Collapsible Config Panel -->
		<div class="collapse mt-3" [ngClass]="{ 'show': routeConfigExpanded }">
			<div class="p-3 border shadow-sm bg-white">
				<!-- Route Config Header -->
				<div class="d-flex justify-content-between align-items-center mb-3">
					<h5 class="mb-0 fw-semibold">Route Configuration</h5>
					<button class="btn btn-outline-primary btn-sm" (click)="openDialog()">Edit Route Configuration</button>
				</div>
	
				<!-- Route Config Content -->
				<div class="route-list-container">
					<div class="d-flex gap-4 overflow-auto">
						<div *ngFor="let item of timelineData" class="timeline-item">
	
							<!-- Node + Connector + Card (same as before) -->
							<div class="d-flex align-items-start gap-3">
								<!-- Node -->
								<div class="position-relative">
									<div class="timeline-node p-3 shadow cursor-pointer"
										[ngClass]="getStatusColorClass(item.status, item.userType)"
										[class.timeline-node-selected]="selectedNode?.id === item.id"
										(click)="handleNodeClick(item)">
										<i [class]="getStatusIconClass(item.status) + ' text-white fs-5'"></i>
	
										<!-- Priority Badge -->
										<span *ngIf="item.priority"
											class="position-absolute top-0 start-100 translate-middle badge rounded-pill"
											[ngClass]="getPriorityColorClass(item.priority)">
											{{ item.priority.toUpperCase() }}
										</span>
	
										<!-- Working Pulse -->
										<div *ngIf="item.status === 'working'" class="working-pulse"></div>
									</div>
	
									<!-- Connector -->
									<div
										[class]="getConnectorClass(item.status, timelineData.indexOf(item), timelineData.length)">
									</div>
								</div>
	
								<!-- Card -->
								<div class="card flex-grow-1 rounded-4 shadow-sm border-0" [ngClass]="{
	                  'card-selected': selectedNode?.id === item.id,
	                  expanded: expandedItems[item.id]
	                }" style="min-width: 300px;">
									<div class="card-header bg-white p-0 border-0">
										<button
											class="btn btn-light w-100 text-start p-3 d-flex justify-content-between align-items-center"
											(click)="toggleExpanded(item.id)">
											<div>
												<h5 class="fw-bold mb-1">{{ item.unit }}</h5>
												<p class="mb-0 small">{{ item.name }}</p>
												<div class="d-flex align-items-center gap-2 mt-2">
													<span class="badge rounded-pill py-1 px-2"
														[ngClass]="getStatusBadgeColorClass(item.status)">
														<i [class]="getStatusIconClass(item.status) + ' me-1 fs-6'"></i>
														{{
														item.status === 'working'
														? 'In Progress'
														: (item.status | titlecase)
														}}
													</span>
													<small class="text-muted d-flex align-items-center gap-1">
														<i class="pi pi-calendar"></i>
														{{ formatTimestamp(item.timestamp) }}
													</small>
												</div>
											</div>
											<i class="pi" [ngClass]="{
	                        'pi-chevron-down': !expandedItems[item.id],
	                        'pi-chevron-up': expandedItems[item.id]
	                      }"></i>
										</button>
									</div>
	
									<!-- Expanded Content -->
									<div class="collapse" [ngClass]="{ 'show': expandedItems[item.id] }">
										<div class="card-body p-3 pt-2 border-top border-light">
											<!-- Internal Users -->
											<div *ngIf="item.hasInternal && item.internalUsers">
												<h6 class="fw-semibold text-dark mb-2">
													<i class="pi pi-users me-2"></i>Internal Team Members
												</h6>
												<div class="d-flex flex-column gap-2">
													<div *ngFor="let user of item.internalUsers"
														class="d-flex justify-content-between align-items-center p-2 rounded-3 bg-light border">
														<div class="d-flex align-items-center gap-2">
															<i [class]="getStatusIconClass(user.status)" [ngClass]="{
	                                'text-success': user.status === 'completed',
	                                'text-primary': user.status === 'working',
	                                'text-secondary': user.status === 'pending'
	                              }"></i>
															<div>
																<p class="mb-0 small">{{ user.name }}</p>
																<p class="mb-0 small">
																	{{ user.permission | titlecase }}
																</p>
															</div>
														</div>
														<span class="badge rounded-pill py-1 px-2 small"
															[ngClass]="getStatusBadgeColorClass(user.status)">
															{{
															user.status === 'working'
															? 'In Progress'
															: (user.status | titlecase)
															}}
														</span>
													</div>
												</div>
											</div>
											<!-- End Internal Users -->
										</div>
									</div>
								</div>
							</div>
							<!-- End Row -->
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

    <!-- ================= Route List ================= -->
</div>
<ng-template #emptyTemplate>
    <div class="route-track empty-track">
        <div class="empty-message">
            No users in the route list
        </div>
    </div>
</ng-template>


<!-- <div class="timeline-container">
  <div class="timeline-arrow">
    <div *ngFor="let step of steps; let i = index" class="step-container">
      <div *ngIf="!step.skipped"
           class="step" [class.arrow-approved]="step.step_status === 'approved'"
           [class.active]="activeIndexCode === step.code"
           [class.completed]="isStepCompleted(step)"
           [class.disabled]="!canNavigateTo(step)"
           (click)="onStepClick(step)">
           
        <div class="step-indicator">
          <span class="step-number">{{ getStepNumber(step) }}</span>
        </div>
        <span class="step-label">{{ step.name }}</span>

        <div class="step-arrow" *ngIf="i < steps.length - 1"></div>
      </div>
    </div>
  </div>
</div> -->

<div class="container-fluid ">
    <!-- <div class="route-list-container mt-3">
        <div class="card">
            <ng-container *ngIf="filteredRouteList?.length > 0; else emptyTemplate">
                <div class="route-track" [class.single-item]="filteredRouteList.length === 1">
                    <div class="route-item" *ngFor="let member of filteredRouteList; let i = index; let last = last">
                       
                        <div class="step-dot" [class.active-dot]="isInProgressPath(member , i)"
                            [class.inactive-dot]="!isInProgressPath(member , i)">
                        </div>

                       
                        <div class="step-connector" [class.active-connector]="isConnectorActive(i)"
                            [class.inactive-connector]="!isConnectorActive(i)" *ngIf="!last">
                        </div>

                        <div class="user-info">
                            <span class="user-name">{{member.user.loginname}}</span>
                            <span class="user-role">
                                {{member.user.rankName}} {{member.user.first_name}} {{member.user.last_name}}
                            </span><br>
                            <span class="user-role">Designation : {{member.user.hrcdf_designation}}</span><br>
                            <span class="user-role">Directorate : {{member.user.unit.name}}</span><br>
                            <span class="user-role">Role : {{member.role.name}}</span>
                        </div>
                    </div>
                </div>
            </ng-container>

            <ng-template #emptyTemplate>
                <div class="route-track empty-track">
                    <div class="empty-message">
                        No users in the route list
                    </div>
                </div>
            </ng-template>
            <div class="d-flex justify-content-end"
                *ngIf="step_details?.is_initiator || step_details?.is_recommender || step_details?.is_approver || userID == '6'">
                <button class="fetch-data-btn mt-3 h-35px" (click)="editeRoute()">
                    <i class="pi pi-users me-2"></i>
                    Edit Route Config
                </button>
            </div>
        </div>
    </div> -->
    <div>
        <div class="custom-tab-container">
            <div class="custom-tab" (click)="onUserGuide('process')" [ngClass]="{'active-tab': userGuide === 'process'}"
                pTooltip="View the complete process flow" tooltipPosition="top">
                Process Flow
            </div>
            <!-- <div class="custom-tab" (click)="onUserGuide('user')" [ngClass]="{'active-tab': userGuide === 'user'}"
                pTooltip="See the hierarchy of users involved" tooltipPosition="top">
                User Hierarchy
            </div> -->
            <div class="custom-tab" (click)="onUserGuide('comments')"
                [ngClass]="{'active-tab': userGuide === 'comments'}" pTooltip="View past comments or notes"
                tooltipPosition="top">
                Comments History
            </div>
            <div class="custom-tab" (click)="onUserGuide('report');getReportList();"
                [ngClass]="{'active-tab': userGuide === 'report'}" pTooltip="Access and view previous report versions"
                tooltipPosition="top">
                <!-- Report Version -->
                Reports
            </div>
            <div class="custom-tab" (click)="onUserGuide('document');getDocumentList();"
                [ngClass]="{'active-tab': userGuide === 'document'}"
                pTooltip="Access and view previously uploaded documents" tooltipPosition="top">
                <!-- Report Version -->
                Documents
            </div>
        </div>
<div class="row">
        <div class="tab-content" [ngClass]="{'col-md-6': userGuide === 'comments'}">
            <div
                *ngIf="userGuide !== 'report'&& userGuide != 'user' && userGuide != 'document'">
                <div class="row p-0">
                    <div class=" card" *ngIf="stapName" [ngClass]="{'process-flow-container': userGuide === 'comments'}">
                        <!-- Initiation & Approval Phase -->
                        <ng-container *ngIf="activeIndexCode == 'idex_001'">
                            <app-idex (generatePDFEmitter)="generatePDF($event)" [id]="stapName.id"
                                (stepCompleted)="goToNextStep()" (IRA)="onIRA($event)" [isEditable]="isEditable"
                                [stepDetails]="step_details" [screening]="'formulation'"></app-idex>
                        </ng-container>

                        <ng-container *ngIf="activeIndexCode == 'I-SC'">
                            <app-idex (generatePDFEmitter)="generatePDF($event)" [id]="stapName.id"
                                (stepCompleted)="goToNextStep()" (IRA)="onIRA($event)" [isEditable]="isEditable"
                                [stepDetails]="step_details" [screening]="'initiation'"></app-idex>
                        </ng-container>
                        <ng-container *ngIf="activeIndexCode == 'C-APPR'">
                            <app-idex (generatePDFEmitter)="generatePDF($event)" [id]="stapName.id"
                                (stepCompleted)="goToNextStep()" (IRA)="onIRA($event)" [isEditable]="isEditable"
                                [stepDetails]="step_details" [screening]="'approval'"></app-idex>
                        </ng-container>

                        <ng-container *ngIf="activeIndexCode == 'IP-V'">
                            <app-ip-valuation (generatePDFEmitter)="generatePDF($event)" [id]="stapName.id"
                                (stepCompleted)="goToNextStep()" (IRA)="onIRA($event)" [isEditable]="isEditable"
                                [stepDetails]="step_details"></app-ip-valuation>
                        </ng-container>


                        <!-- Development Agreement -->

                        <ng-container *ngIf="activeIndexCode === 'L-CH'">
                            <app-launch-challenge [proposalName]="proposalName" [isEditable]="isEditable"
                                (generatePDFEmitter)="generatePDF($event)" [id]="stapName.id" [step]="stapName"
                                (stepCompleted)="goToNextStep()" (IRA)="onIRA($event)" [stepDetails]="step_details"
                                [proposalId]="proposalId"></app-launch-challenge>
                        </ng-container>

                        <ng-container *ngIf="activeIndexCode === 'I-UP' ">
                            <app-idex-response [proposalName]="proposalName" [proposalId]="proposalId" [step]="stapName"
                                (generatePDFEmitter)="generatePDF($event)" [schemeType]="'idex'" [id]="stapName.id"
                                (stepCompleted)="goToNextStep()" (IRA)="onIRA($event)" [isEditable]="isEditable"
                                [stepDetails]="step_details"></app-idex-response>
                        </ng-container>

                        <ng-container *ngIf="activeIndexCode ===  'idex_004'">
                            <app-constitute-committee [id]="stapName.id" [step]="stapName"
                                [title]="'Constitute HPSC , PFT Committee'" [getUrl]="'revenue/constitute-committee/'"
                                [postUrl]="'revenue/constitute-committee/'" (IRA)="onIRA($event)"
                                (generatePDFEmitter)="generatePDF($event)" (stepCompleted)="goToNextStep()"
                                [isEditable]="isEditable" [stepDetails]="step_details"></app-constitute-committee>
                        </ng-container>

                        <ng-container *ngIf="activeIndexCode === 'idex_005'">
                            <div class="container-fluid p-3">
                                <div class="page-header mb-4">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <div>
                                            <h4 class="mb-1">Evaluation by HPSC</h4>
                                            <h5 class="text-primary">[{{proposalName}}]</h5>
                                            <div class="status-badge">
                                                <span class="badge" [ngClass]="{
                                                              'bg-secondary': step_details?.step_status == 0,
                                                              'bg-success': step_details?.step_status == 'approved',
                                                              'bg-warning': step_details?.step_status == 'recommended',
                                                              'bg-info': step_details?.step_status == 'initiated'
                                                            }">
                                                    {{
                                                    step_details?.step_status == 0
                                                    ? "INITIATION PENDING"
                                                    : (step_details?.step_status | uppercase)
                                                    }}
                                                </span>
                                            </div>
                                        </div>

                                        <div class="action-buttons">
                                            <!-- <button class="btn btn-outline-secondary me-2" (click)="generatePDF()">
                                                <i class="pi pi-file-pdf me-1"></i> PDF
                                            </button> -->

                                            <ng-container *ngIf="step_details?.step_status == 'approved'">
                                                <button class="btn btn-outline-primary me-2" (click)="goToNextStep()">
                                                    Next <i class="pi pi-angle-right ms-1"></i>
                                                </button>
                                            </ng-container>

                                            <ng-container *ngIf="
                                                        step_details?.is_initiator ||
                                                        step_details?.is_approver ||
                                                        step_details?.is_recommender ||
                                                        (step_details?.step_status != 'approved' && userID == 6)
                                                      ">
                                                <button class="btn btn-primary me-2" [disabled]="isFormInvalid()"
                                                    (click)="onJustificationSubmit()">
                                                    <i class="pi pi-save me-1"></i> Save
                                                </button>
                                            </ng-container>

                                            <ng-container *ngIf="step_details?.is_initiator">
                                                <button class="btn btn-success" (click)="IRA.emit('Initiate')">
                                                    <i class="pi pi-play me-1"></i> Initiate
                                                </button>
                                            </ng-container>

                                            <ng-container *ngIf="step_details?.is_approver">
                                                <button class="btn btn-success" (click)="IRA.emit('Approve')">
                                                    <i class="pi pi-check-circle me-1"></i> Approve
                                                </button>
                                            </ng-container>

                                            <ng-container *ngIf="step_details?.is_recommender">
                                                <button class="btn btn-info" (click)="IRA.emit('Recommend')">
                                                    <i class="pi pi-thumbs-up me-1"></i> Recommend
                                                </button>
                                            </ng-container>
                                        </div>
                                    </div>
                                </div>

                                <hr class="my-3" />
                                <div class="card p-3 mb-4">
                                    <h5 class="mb-3">HPSC : Evaluation Sheet</h5>

                                    <div class="row mb-3">
                                        <div class="col-md-6">
                                            <label>Challenge Title:</label>
                                            <input type="text" class="p-inputtext w-100"
                                                [(ngModel)]="evaluation.challengeTitle" disabled />
                                        </div>
                                        <div class="col-md-6">
                                            <label>Name of the Evaluator:</label>
                                            <input type="text" class="p-inputtext w-100"
                                                [(ngModel)]="evaluation.evaluatorName" />
                                        </div>
                                    </div>

                                    <div class="row mb-3">
                                        <div class="col-md-6">
                                            <label>Category (DISC/OC/ADITI etc.):</label>
                                            <input type="text" class="p-inputtext w-100"
                                                [(ngModel)]="evaluation.category" disabled />
                                        </div>
                                        <div class="col-md-6">
                                            <label>Organisation of the Evaluator:</label>
                                            <input type="text" class="p-inputtext w-100"
                                                [(ngModel)]="evaluation.organisation" />
                                        </div>
                                    </div>

                                    <div class="row mb-3">
                                        <div class="col-md-6">
                                            <label>Nodal Agency:</label>
                                            <input type="text" class="p-inputtext w-100"
                                                [(ngModel)]="evaluation.nodalAgency" disabled />
                                        </div>
                                        <div class="col-md-6">
                                            <label>Contact Details:</label>
                                            <input type="text" class="p-inputtext w-100" maxlength="10" minlength="10"
                                                (keypress)="allowOnlyNumbers($event)"
                                                [(ngModel)]="evaluation.contact" />
                                        </div>
                                    </div>

                                    <div class="row mb-3">
                                        <div class="col-md-6">
                                            <label>Date of Evaluation:</label>
                                            <input type="date" class="p-inputtext w-100"
                                                [(ngModel)]="evaluation.date" />
                                        </div>
                                        <div class="col-md-6">
                                            <label>Email ID:</label>
                                            <input type="email" class="p-inputtext w-100"
                                                [(ngModel)]="evaluation.email" />
                                        </div>
                                    </div>
                                </div>

                                <p-table [value]="entries" styleClass="p-datatable-gridlines" class="mb-4 ">
                                    <ng-template pTemplate="header">
                                        <tr>
                                            <th rowspan="2">Rank</th>
                                            <th rowspan="2">Applicant Name</th>
                                            <th rowspan="2">Company Name</th>
                                            <th colspan="6">Evaluation Criteria</th>
                                            <th rowspan="2">Total (60)</th>
                                            <th rowspan="2">Percenatge (%)</th>
                                            <th rowspan="2">Remarks</th>
                                            <th rowspan="2">Status</th>
                                            <th rowspan="2">Action</th>
                                        </tr>
                                        <tr>
                                            <th>Relevance (10)</th>
                                            <th>Comprehensiveness (10)</th>
                                            <th>Innovation (10)</th>
                                            <th>Feasibility (10)</th>
                                            <th>Capability (10)</th>
                                            <th>Viability (10)</th>
                                        </tr>
                                    </ng-template>

                                    <ng-template pTemplate="body" let-entry let-rowIndex="rowIndex">
                                        <tr>
                                            <!-- Rank -->
                                            <td>
                                                <span *ngIf="!entry.isEditMode">{{ entry.rank }}</span>
                                                <input *ngIf="entry.isEditMode" [(ngModel)]="entry.rank" pInputText
                                                    [disabled]="!isEditable" />
                                            </td>

                                            <!-- Serial -->
                                            <td>{{ entry.vendor?.name }}</td>

                                            <!-- Applicant Name -->
                                            <td>
                                                <span>{{ entry.vendor?.name }}</span>
                                            </td>

                                            <!-- Evaluation Criteria Fields -->
                                            <td>
                                                <span *ngIf="!entry.isEditMode">{{ entry.relevance }}</span>
                                                <input *ngIf="entry.isEditMode" type="number"
                                                    [(ngModel)]="entry.relevance" pInputText [min]="0" [max]="10"
                                                    (ngModelChange)="validateScore(entry, 'relevance')"
                                                    [disabled]="!isEditable" />
                                            </td>
                                            <td>
                                                <span *ngIf="!entry.isEditMode">{{ entry.comprehensiveness }}</span>
                                                <input *ngIf="entry.isEditMode" type="number"
                                                    [(ngModel)]="entry.comprehensiveness" pInputText [min]="0"
                                                    [max]="10" [disabled]="!isEditable"
                                                    (ngModelChange)="validateScore(entry, 'comprehensiveness')" />
                                            </td>
                                            <td>
                                                <span *ngIf="!entry.isEditMode">{{ entry.innovation }}</span>
                                                <input *ngIf="entry.isEditMode" type="number" [disabled]="!isEditable"
                                                    [(ngModel)]="entry.innovation" pInputText [min]="0" [max]="10"
                                                    (ngModelChange)="validateScore(entry, 'innovation')" />
                                            </td>
                                            <td>
                                                <span *ngIf="!entry.isEditMode">{{ entry.feasibility }}</span>
                                                <input *ngIf="entry.isEditMode" type="number" [disabled]="!isEditable"
                                                    [(ngModel)]="entry.feasibility" pInputText [min]="0" [max]="10"
                                                    (ngModelChange)="validateScore(entry, 'feasibility')" />
                                            </td>
                                            <td>
                                                <span *ngIf="!entry.isEditMode">{{ entry.capability }}</span>
                                                <input *ngIf="entry.isEditMode" type="number" [disabled]="!isEditable"
                                                    [(ngModel)]="entry.capability" pInputText [min]="0" [max]="10"
                                                    (ngModelChange)="validateScore(entry, 'capability')" />
                                            </td>
                                            <td>
                                                <span *ngIf="!entry.isEditMode">{{ entry.viability }}</span>
                                                <input *ngIf="entry.isEditMode" type="number" [disabled]="!isEditable"
                                                    [(ngModel)]="entry.viability" pInputText [min]="0" [max]="10"
                                                    (ngModelChange)="validateScore(entry, 'viability')" />
                                            </td>

                                            <!-- Total -->
                                            <td>{{ entry.total }}</td>
                                            <td>{{ entry.percentage }}</td>

                                            <!-- Remarks -->
                                            <td>
                                                <span *ngIf="!entry.isEditMode">{{ entry.remarks }}</span>
                                                <input *ngIf="entry.isEditMode" [(ngModel)]="entry.remarks" pInputText
                                                    [disabled]="!isEditable" />
                                            </td>

                                            <!-- Status -->
                                            <td>
                                                <div *ngIf="entry.isEditMode">
                                                    <p-radioButton name="status{{ rowIndex }}" value="Qualified"
                                                        [(ngModel)]="entry.status"
                                                        [disabled]="!isEditable || entry.total <= 0"
                                                        inputId="q{{ rowIndex }}"></p-radioButton>
                                                    <label for="q{{ rowIndex }}">Qualified</label><br />
                                                    <p-radioButton name="status{{ rowIndex }}" value="Disqualified"
                                                        [(ngModel)]="entry.status"
                                                        [disabled]="!isEditable || entry.total <= 0"
                                                        inputId="d{{ rowIndex }}"></p-radioButton>
                                                    <label for="d{{ rowIndex }}">Disqualified</label>
                                                </div>
                                                <span *ngIf="!entry.isEditMode">
                                                    {{entry.vendor_status}}
                                                </span>
                                            </td>

                                            <!-- Action -->
                                            <td>
                                                <button *ngIf="!entry.isEditMode && isEditable" pButton type="button"
                                                    icon="pi pi-pencil" label="Edit" (click)="entry.isEditMode = true"
                                                    class="btn btn-primary fetch-data-btn"></button>

                                                <button *ngIf="entry.isEditMode && isEditable" pButton type="button"
                                                    icon="pi pi-check" label="Save"
                                                    class="btn btn-primary fetch-data-btn"
                                                    (click)="saveRow(entry)"></button>
                                            </td>
                                        </tr>
                                    </ng-template>
                                </p-table>

                                <!-- <div class="mt-4">
                                    <form [formGroup]="commentForm">
                                        <div class="form-group mb-4 editor-container"
                                            [class.readonly-editor]="isEditorDisabled">
                                            <label for="pdsTitle"><strong>• Justification</strong></label>
                                            <editor [init]="init" formControlName="comment"
                                                [disabled]="isEditorDisabled"></editor>
                                        </div>

                                    </form>
                                </div> -->

                                <!-- Document Upload Section -->
                                <div class="row mb-4 mt-4">
                                    <div class="col-lg-8">
                                        <div class="card shadow-sm border-0">
                                            <div class="card-body p-4">
                                                <div class="d-flex align-items-center mb-3">
                                                    <i class="pi pi-file text-primary me-2"></i>
                                                    <h5 class="card-title mb-0">HPSC Evaluation Document</h5>
                                                </div>

                                                <p class="text-muted mb-4">Please upload your document in PDF, DOCX,
                                                    CSV, JPEG, JPG, or PNG format (Max size: 200MB)</p>

                                                <!-- Upload Area -->
                                                <!-- <div class="upload-container mb-4"
                                                    *ngIf="step_details?.is_initiator || step_details?.is_approver || step_details?.is_recommender || (step_details?.step_status != 'approved' && userID == 6)">
                                                    <div class="upload-area p-4 text-center border rounded">


                                                        <p-fileUpload mode="basic" chooseLabel="Browse Files"
                                                            (uploadHandler)="onUpload($event)" [auto]="true"
                                                            [customUpload]="true" #fileUpload [multiple]="false"
                                                            [accept]="'.pdf,.docx,.csv,.jpeg,.jpg,.png'"
                                                            [maxFileSize]="209715200"
                                                            styleClass="p-button-rounded p-button-outlined">
                                                        </p-fileUpload>
                                                    </div>
                                                </div> -->
                                                <app-upload-document></app-upload-document>

                                                <!-- Uploaded File Display -->
                                                <div *ngIf="uploadedFileName || uploadedUrl">
                                                    <div
                                                        class="uploaded-file-card p-3 bg-light rounded d-flex justify-content-between align-items-center">
                                                        <div class="d-flex align-items-center">
                                                            <i class="pi pi-file me-3 text-primary"
                                                                style="font-size: 1.5rem;"></i>
                                                            <div>
                                                                <p class="mb-0 fw-semibold">
                                                                    <a [href]="apiUrl + uploadedUrl" target="_blank"
                                                                        class="text-decoration-none">
                                                                        {{ uploadedFileName || getFileName(uploadedUrl)
                                                                        }}
                                                                    </a>
                                                                </p>
                                                                <small class="text-muted"
                                                                    *ngIf="uploadedFileName">Uploaded
                                                                    successfully</small>
                                                            </div>
                                                        </div>
                                                        <div class="d-flex gap-2">
                                                            <a [href]="apiUrl + uploadedUrl" target="_blank"
                                                                class="btn btn-sm btn-outline-primary"
                                                                *ngIf="uploadedUrl">
                                                                <i class="pi pi-eye"></i>
                                                            </a>
                                                            <!-- <button class="btn btn-sm btn-outline-danger"> -->
                                                            <i class="pi pi-times" (click)="clearUpload(fileUpload)"
                                                                *ngIf="uploadedFileName"></i>
                                                            <!-- </button> -->
                                                        </div>
                                                    </div>
                                                </div>

                                                <!-- No Files State -->
                                                <div *ngIf="!uploadedFileName && !uploadedUrl && 
                                                                      !(step_details?.is_initiator || step_details?.is_approver || step_details?.is_recommender || 
                                                                      (step_details?.step_status != 'approved' && userID == 6))"
                                                    class="no-file-placeholder p-3 text-center bg-light rounded">
                                                    <i class="pi pi-inbox text-muted mb-2"
                                                        style="font-size: 1.5rem;"></i>
                                                    <p class="mb-0 text-muted">No files uploaded</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-container>

                        <ng-container *ngIf="activeIndexCode ==='idex_006' ">
                            <app-idex-winners [data]="winner" [proposalName]="proposalName" [proposalId]="proposalId"
                                (generatePDFEmitter)="generatePDF($event)" 
                                [step]="stapName" [isEditable]="isEditable"
                                [stepDetails]="step_details"></app-idex-winners>
                        </ng-container>

                        <ng-container *ngIf="activeIndexCode == 'IPV'">
                            <app-ip-value (generatePDFEmitter)="generatePDF($event)" [id]="stapName.id"
                                (stepCompleted)="goToNextStep()" (IRA)="onIRA($event)" [isEditable]="isEditable"
                                [stepDetails]="step_details"></app-ip-value>
                        </ng-container>

                        <ng-container *ngIf="activeIndexCode == 'I-PS'">
                            <app-share-pds-pru (generatePDFEmitter)="generatePDF($event)" [id]="stapName.id"
                                [proposalName]="proposalName" [proposalId]="proposalId" (stepCompleted)="goToNextStep()"
                                (IRA)="onIRA($event)" [isEditable]="isEditable"
                                [stepDetails]="step_details"></app-share-pds-pru>
                        </ng-container>

                        <ng-container *ngIf="activeIndexCode == 'I-UPS'">
                            <app-upload-pds-pru (generatePDFEmitter)="generatePDF($event)" [id]="stapName.id"
                                [proposalName]="proposalName" [proposalId]="proposalId" [format]="'upload'"
                                (stepCompleted)="goToNextStep()" (IRA)="onIRA($event)" [isEditable]="isEditable"
                                [stepDetails]="step_details"></app-upload-pds-pru>
                        </ng-container>

                        <ng-container *ngIf="activeIndexCode == 'idex_014'">
                            <app-idex-bids (generatePDFEmitter)="generatePDF($event)" [id]="stapName.id"
                                [proposalName]="proposalName" [proposalId]="proposalId" (stepCompleted)="goToNextStep()"
                                (IRA)="onIRA($event)" [isEditable]="isEditable"
                                [stepDetails]="step_details"></app-idex-bids>
                        </ng-container>

                        <ng-container *ngIf="activeIndexCode == 'I-TE'">
                            <app-idex-bids (generatePDFEmitter)="generatePDF($event)" [id]="stapName.id"
                                [proposalName]="proposalName" [proposalId]="proposalId" [format]="'upload'"
                                (stepCompleted)="goToNextStep()" (IRA)="onIRA($event)" [isEditable]="isEditable"
                                [stepDetails]="step_details"></app-idex-bids>
                        </ng-container>

                        <ng-container *ngIf="activeIndexCode == 'I-UDA'">
                            <app-spark-agreement [id]="stapName.id" [getUrl]="'revenue/final-offer/'"
                                [postUrl]="'revenue/final-offer/'" (generatePDFEmitter)="generatePDF($event)"
                                (stepCompleted)="goToNextStep()" (IRA)="onIRA($event)" 
                                [stepDetails]="step_details" [schemeType]="'idex'"></app-spark-agreement>
                        </ng-container>

                        <ng-container *ngIf="activeIndexCode ==='RFP-V' ">
                            <app-pre-rfp-meeting [id]="stapName.id" [step]="stapName"
                                [getUrl]="'revenue/pre-rfp-meeting/'" [postUrl]="'revenue/pre-rfp-meeting/'"
                                (generatePDFEmitter)="generatePDF($event)" (stepCompleted)="goToNextStep()"
                                (IRA)="onIRA($event)" [isEditable]="isEditable" [schemeType]="'idex'"
                                [stepDetails]="step_details"></app-pre-rfp-meeting>
                        </ng-container>

                        <ng-container *ngIf="activeIndexCode ==='I-RFP' ">
                            <app-idex-commercial-rfp [id]="proposalId" [step]="stapName" [proposalName]="proposalName"
                                (generatePDFEmitter)="generatePDF($event)" (stepCompleted)="goToNextStep()"
                                (IRA)="onIRA($event)" [isEditable]="isEditable"
                                [stepDetails]="step_details"></app-idex-commercial-rfp>
                        </ng-container>

                        <ng-container *ngIf="activeIndexCode ===  'tdf_005'">
                            <app-constitute-committee [id]="stapName.id" [step]="stapName"
                                [title]="'Constitute Committee'" [getUrl]="'revenue/constitute-committee/'"
                                [postUrl]="'revenue/constitute-committee/'" (IRA)="onIRA($event)"
                                (generatePDFEmitter)="generatePDF($event)" (stepCompleted)="goToNextStep()"
                                [isEditable]="isEditable" [stepDetails]="step_details"></app-constitute-committee>
                        </ng-container>

                        <ng-container *ngIf="activeIndexCode ==='R-BM' ">
                            <app-banchmark [id]="stapName.id" [step]="stapName" (stepCompleted)="goToNextStep()"
                                (IRA)="onIRA($event)" [isEditable]="isEditable"
                                (generatePDFEmitter)="generatePDF($event)" [stepDetails]="step_details"></app-banchmark>
                        </ng-container>

                        <ng-container *ngIf="activeIndexCode === 'tdf_006' ">
                            <app-commercial-negocatition [id]="stapName.id" [isEditable]="isEditable" [step]="stapName"
                                (stepCompleted)="goToNextStep()" (IRA)="onIRA($event)"
                                (generatePDFEmitter)="generatePDF($event)" [stepDetails]="step_details"
                                [schemeType]="'idex'"></app-commercial-negocatition>
                        </ng-container>

                        <ng-container *ngIf="activeIndexCode ==='R-PSO' ">
                            <app-sanction-order [id]="stapName.id" [step]="stapName" (stepCompleted)="goToNextStep()"
                                (IRA)="onIRA($event)" [isEditable]="isEditable"
                                (generatePDFEmitter)="generatePDF($event)" [stepDetails]="step_details"
                                [schemeType]="'idex'"></app-sanction-order>
                        </ng-container>

                        <!-- SQR -->
                        <ng-container *ngIf="activeIndexCode == 'makeI_07'">
                            <app-psqr [id]="stapName.id" [proposalName]="proposalName" [proposalId]="proposalId"
                                [isEditable]="isEditable" (IRA)="onIRA($event)" (stepCompleted)="goToNextStep()"
                                (generatePDFEmitter)="generatePDF($event)" [stepDetails]="step_details"
                                [schemeType]="'idex'"></app-psqr>
                        </ng-container>

                        <ng-container *ngIf="activeIndexCode == 'makeI_23'">
                            <app-psqr [id]="stapName.id" [proposalName]="proposalName" [proposalId]="proposalId"
                                [isEditable]="isEditable" (IRA)="onIRA($event)" (stepCompleted)="goToNextStep()"
                                (generatePDFEmitter)="generatePDF($event)" [stepDetails]="step_details"
                                [schemeType]="'idex'"></app-psqr>
                        </ng-container>


                        <!-- Prototype Deveploment -->
                        <ng-container *ngIf="activeIndexCode ===  'U-BS'">
                            <app-upload-wbs [proposalName]="proposalName" [isEditable]="isEditable"
                                (generatePDFEmitter)="generatePDF($event)" [id]="stapName.id" [step]="stapName"
                                (stepCompleted)="goToNextStep()" (IRA)="onIRA($event)" [stepDetails]="step_details"
                                [proposalId]="proposalId"></app-upload-wbs>
                        </ng-container>

                        <ng-container *ngIf="activeIndexCode === 'M-WBS'">
                            <app-map-wbs-payment [proposalName]="proposalName" [isEditable]="isEditable"
                                (generatePDFEmitter)="generatePDF($event)" [id]="stapName.id" [step]="stapName"
                                (stepCompleted)="goToNextStep()" (IRA)="onIRA($event)" [stepDetails]="step_details"
                                [proposalId]="proposalId"></app-map-wbs-payment>
                        </ng-container>


                        <!-- SSCT -->
                        <ng-container *ngIf="activeIndexCode ===  'I-SSCT'">
                            <app-constitute-committee [id]="stapName.id" [step]="stapName" [title]="'Constitute SSCT'"
                                [getUrl]="'revenue/constitute-committee/'" [postUrl]="'revenue/constitute-committee/'"
                                (IRA)="onIRA($event)" (generatePDFEmitter)="generatePDF($event)"
                                (stepCompleted)="goToNextStep()" [isEditable]="isEditable"
                                [stepDetails]="step_details"></app-constitute-committee>
                        </ng-container>

                        <ng-container *ngIf="activeIndexCode === 'make1_009'">
                            <app-ssct [proposalName]="proposalName" [isEditable]="isEditable"
                                (generatePDFEmitter)="generatePDF($event)" [id]="stapName.id" [step]="stapName"
                                (stepCompleted)="goToNextStep()" (IRA)="onIRA($event)" [stepDetails]="step_details"
                                [proposalId]="proposalId"></app-ssct>
                        </ng-container>








                        <ng-container *ngIf="activeIndexCode ==='idex_002' ">
                            <app-idex-sqr (generatePDFEmitter)="generatePDF($event)" [id]="stapName.id"
                                (stepCompleted)="goToNextStep()" (IRA)="onIRA($event)" [isEditable]="isEditable"
                                [stepDetails]="step_details"></app-idex-sqr>
                        </ng-container>
                        <ng-container *ngIf="activeIndexCode === 'R-VI' ">
                            <!-- <div class="p-3">
                                <div class="d-flex justify-content-between my-4 mx-3">
                                    <h5>List of Vendors - <span class="text-primary"> [{{proposalName}}]</span></h5>
                                </div>
                                <hr>
                                <app-data-table [columns]="cols" [data]="vendors" title="List of Vendors"
                                    [isEditable]="true" [isDeletable]="true"></app-data-table>
                            </div> -->
                            <app-vendor [id]="stapName.id" [step]="stapName" (stepCompleted)="goToNextStep()"
                                (IRA)="onIRA($event)" [isEditable]="isEditable" [schemeType]="'idex'"
                                [stepDetails]="step_details"></app-vendor>
                        </ng-container>




                        <ng-container *ngIf="activeIndexCode === 'idex_007'">
                            <app-idex-prototype [data]="winner" [proposalName]="proposalName" [proposalId]="proposalId"
                                [step]="stapName" (generatePDFEmitter)="generatePDF($event)" [schemeType]="'idex'"
                                (stepCompleted)="goToNextStep()" (IRA)="onIRA($event)" [isEditable]="isEditable"
                                [stepDetails]="step_details"></app-idex-prototype>
                        </ng-container>

                        <!-- <ng-container *ngIf="activeIndexCode === 'tdf_005'">
                            <div class="p-3">
                                <app-constitute-committee [id]="stapName.id" [step]="stapName"
                                    [getUrl]="'revenue/constitute-committee/'" [title]="'Constitute Committee'"
                                    [postUrl]="'revenue/constitute-committee/'"
                                    (generatePDFEmitter)="generatePDF($event)"></app-constitute-committee>
                            </div>
                        </ng-container> -->

                        <ng-container *ngIf="activeIndexCode === 'idex_009'">
                            <app-idex-utrr (generatePDFEmitter)="generatePDF($event)" [step]="stapName" [data]="winner"
                                [id]="stapName?.id" (stepCompleted)="goToNextStep()" (IRA)="onIRA($event)"
                                [isEditable]="isEditable" [stepDetails]="step_details"
                                [schemeType]="'idex'"></app-idex-utrr>
                        </ng-container>
                        <ng-container *ngIf="activeIndexCode ==='R-RFP-SOC' ">
                            <app-idex-rfp-soc (generatePDFEmitter)="generatePDF($event)" [proposalName]="proposalName"
                                [masterData]="MasterData" [step]="stapName" (stepCompleted)="goToNextStep()"
                                (IRA)="onIRA($event)" [isEditable]="isEditable"
                                [stepDetails]="step_details"></app-idex-rfp-soc>
                        </ng-container>
                        <ng-container *ngIf="activeIndexCode ==='R-AoN' ">
                            <app-aon [id]="stapName.id" [step]="stapName" (stepCompleted)="goToNextStep()"
                                (IRA)="onIRA($event)" [isEditable]="isEditable" [stepDetails]="step_details"></app-aon>
                        </ng-container>


                        <ng-container *ngIf="activeIndexCode ==='idex_014' ">
                            <!-- <app-tender-opening [id]="stapName.id" [step]="stapName"
                                [getUrl]="'revenue/tender-opening/'" [postUrl]="'revenue/tender-opening/'"
                                (generatePDFEmitter)="generatePDF($event)" (stepCompleted)="goToNextStep()"
                                (IRA)="onIRA($event)" [isEditable]="isEditable" [schemeType]="'idex'"
                                [stepDetails]="step_details"></app-tender-opening> -->
                        </ng-container>
                        <ng-container *ngIf="activeIndexCode ==='R-TEC' ">
                            <!-- <app-idex-fet (stepCompleted)="goToNextStep()" (IRA)="onIRA($event)"  [step]="stapName"  [proposalName]="proposalName"
                                [isEditable]="isEditable" [stepDetails]="step_details"></app-idex-fet> -->
                            <app-technical-eveluation [id]="stapName.id" [step]="stapName"
                                (generatePDFEmitter)="generatePDF($event)" (stepCompleted)="goToNextStep()"
                                (IRA)="onIRA($event)" [isEditable]="isEditable" [stepDetails]="step_details"
                                [schemeType]="'idex'"></app-technical-eveluation>
                        </ng-container>

                        <ng-container *ngIf="activeIndexCode ==='idex_17' ">
                            <app-commercial-evaluation [id]="stapName.id" [step]="stapName"
                                (generatePDFEmitter)="generatePDF($event)" (stepCompleted)="goToNextStep()"
                                (IRA)="onIRA($event)" [isEditable]="isEditable" [stepDetails]="step_details"
                                [schemeType]="'idex'"></app-commercial-evaluation>
                        </ng-container>

                        <ng-container *ngIf="activeIndexCode ==='idex_19' ">
                            <app-final-offer [id]="stapName.id" [step]="stapName" [getUrl]="'revenue/final-offer/'"
                                [postUrl]="'revenue/final-offer/'" (generatePDFEmitter)="generatePDF($event)"
                                (stepCompleted)="goToNextStep()" (IRA)="onIRA($event)" [isEditable]="isEditable"
                                [stepDetails]="step_details" [schemeType]="'idex'"></app-final-offer>
                        </ng-container>



                    </div>
                </div>
            </div>
            <div *ngIf="userGuide == 'user'">
                <div class=" ms-3 me-2 card p-2">
                    <div class="card-body">
                        <h4 class="mb-3"><strong>User Hierarchy</strong></h4>
                        <p class="text-muted">People working on this project</p>

                        <div class="d-flex align-items-center justify-content-between mb-3"
                            *ngFor="let member of routeList">
                            <div class="d-flex align-items-center gap-2">
                                <div class="icon-alert p-3 rounded-circle">
                                    <i class="fa-regular fa-user fa-2x"></i>
                                </div>
                                <div>
                                    <h5 class="mb-0 text-dark">{{member.user.loginname}}
                                    </h5>
                                    <h6 class="mb-0 text-dark"> {{member.user.rankName}} {{member.user.first_name}}
                                        {{member.user.last_name}}
                                    </h6>
                                    <small class="text-muted">{{member.role.name}}</small>
                                </div>
                            </div>
                            <!-- <button class="btn  p-0">
                                        <i class="fa-regular fa-message fa-lg"></i>
                                    </button> -->
                        </div>

                        <!-- <button class="fetch-data-btn h-35px w-100 mt-3" (click)="editeRoute()">
                                    <i class="pi pi-users me-2"></i>
                                    Manage Route
                                </button> -->
                    </div>
                </div>
            </div>
            
            <div class="card p-4" *ngIf="userGuide === 'report'">
                <div>
                    <div class="d-flex justify-content-start">
                        <h4>Reports</h4>
                        <!-- <button class="btn btn-primary" (click)="onUserGuide('report');getReportList()">Refresh</button> -->
                    </div>
                    <hr>

                    <!-- If reportList has items -->
                    <div *ngIf="reportList && reportList.length > 0; else noReports">
                        <h5>Report Version</h5>
                        <p-table class="mx-5 mb-4" [value]="reportList" [paginator]="reportList.length > 10"
                            [rows]="10">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th>Version Name</th>
                                    <th>Date</th>
                                    <!-- <th>User</th> -->
                                    <th>Action</th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-item>
                                <tr>
                                    <td>{{ item.name }}</td>
                                    <td>{{ item.modified_on | date: 'medium' }}</td>
                                    <!-- <td>{{ item.user }}</td> -->
                                    <td (click)="pdfconvert(item.paragraph)">
                                        <a class="view-link">View</a>
                                    </td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </div>

                    <!-- Template shown when reportList is empty -->
                    <ng-template #noReports>
                        <div class="text-center mt-4">
                            <p class="text-muted">No reports available at the moment.</p>
                        </div>
                    </ng-template>
                </div>
            </div>

            <div class="card p-4" *ngIf="userGuide === 'document'">
                <div>
                    <div class="d-flex justify-content-start">
                        <h4>Documents</h4>
                        <!-- <button class="btn btn-primary" (click)="onUserGuide('report');getReportList()">Refresh</button> -->
                    </div>
                    <hr>

                    <!-- If documentList has items -->
                    <div *ngIf="documentList && documentList.length > 0; else noDocuments">
                        <h5>Documents Available</h5>
                        <p-table class="mx-5 mb-4" [value]="documentList" [paginator]="documentList.length > 10"
                            [rows]="10">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th>Document Name</th>
                                    <th>View</th>
                                    <th>Download</th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-item>
                                <tr>
                                    <td>{{ item.name }}</td>
                                    <td>
                                        <button class="btn btn-sm btn-link" (click)="viewDocument(item)">
                                            <i class="pi pi-eye"></i>
                                        </button>
                                    </td>
                                    <td>
                                        <button class="btn btn-sm btn-link" (click)="downloadDocument(item)">
                                            <i class="pi pi-download"></i>
                                        </button>
                                    </td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </div>

                    <!-- Template shown when documentList is empty -->
                    <ng-template #noDocuments>
                        <div class="text-center mt-4">
                            <p class="text-muted">No documents available at the moment.</p>
                        </div>
                    </ng-template>
                </div>
            </div>
        </div>
        <div *ngIf="userGuide === 'comments'" class="col-md-6">
                <div class="card">
                    <app-commenting-seet [id]="stapName.id"></app-commenting-seet>
                </div>
            </div>
            </div>
    </div>

    <p-dialog header="Configure Route" [(visible)]="visible" [modal]="true" [resizable]="false" [closable]="true"
        appendTo="body" [style]="{width: '800px'}" [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
        [maximizable]="true">
        <div class="p-3 ">
            <div class="route-list-container ">
                <div class="">
                    <ng-container *ngIf="filteredRouteList?.length > 0; else emptyTemplate">
                        <div class="route-track" [class.single-item]="filteredRouteList.length === 1">
                            <div class="route-item"
                                *ngFor="let member of filteredRouteList; let i = index; let last = last">
                                <!-- Dot -->
                                <div class="step-dot" [class.active-dot]="isInProgressPath(member , i)"
                                    [class.inactive-dot]="!isInProgressPath(member , i)">
                                </div>

                                <!-- Connector -->
                                <div class="step-connector" [class.active-connector]="isConnectorActive(i)"
                                    [class.inactive-connector]="!isConnectorActive(i)" *ngIf="!last">
                                </div>

                                <div class="user-info">
                                    <span class="user-name">{{member.user.loginname}}</span>
                                    <span class="user-role">
                                        {{member.user.rankName}} {{member.user.first_name}} {{member.user.last_name}}
                                    </span><br>
                                    <span class="user-role">Designation : {{member.user.hrcdf_designation}}</span><br>
                                    <span class="user-role">Directorate : {{member.user.unit.name}}</span><br>
                                    <span class="user-role">Role : {{member.role.name}}</span>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>

            <form [formGroup]="routeForm" (ngSubmit)="onrouteFormSubmit()">
                <!-- <div class="row"> -->
                <!-- <div class="col-md-6 mb-3 ">
						<label>Steps</label>
						<p-dropdown [options]="stagesList" formControlName="step" optionValue="id" optionLabel="name"
							[filter]="true" filterBy="name" placeholder="Select a Stage" class="w-100"
							(onChange)="onStepChange($event)">
						</p-dropdown>
					</div> -->
                <div class="col-md-12 mb-3">
                    <label>Role</label>
                    <p-dropdown [options]="roleList" formControlName="role" optionValue="id" optionLabel="name"
                        [filter]="true" filterBy="name" placeholder="Select a Role" class="w-100"
                        (onChange)="onRoleChange($event)" appendTo="body">
                    </p-dropdown>
                </div>
                <!-- <div class="col-md-6 mb-3">
						<label>Directorate</label>
						<p-dropdown [options]="unitList" formControlName="unit" optionValue="id" optionLabel="name"
							placeholder="Select a Directorate" class="w-100" (onChange)="onUnitChange($event)"
							[filter]="true" filterBy="name" appendTo="body">
						</p-dropdown>
					</div> -->
                <div class="col-md-12 mb-3">
                    <label>User</label>
                    <p-dropdown [options]="userList" formControlName="user" optionValue="id" optionLabel="first_name"
                        placeholder="Select a User" class="w-100" [filter]="true" filterBy="first_name" appendTo="body"
                        (onChange)="onUserChange($event)">
                        <ng-template let-user pTemplate="item">
                            <div class="list-group-item list-group-item-action col-md-6">
                                <small> {{user.unit.name}} - {{user.hrcdf_designation}} {{ user.first_name }} {{
                                    user.last_name }} - {{ user.loginname }}</small>
                            </div>
                        </ng-template>
                    </p-dropdown>
                </div>
                <!-- </div> -->
                <!-- <div class="col-md-6 mb-3 flex-col">
						<label for="menuIcon">Sequence</label>
						<input id="menuIcon" type="text" pInputText formControlName="level" placeholder="Enter Sequence"
							class="w-100" />
					</div> -->
                <div class=" mb-3 d-flex justify-content-end">
                    <!-- <div class=" mb-3 ad-user">
							<p-checkbox formControlName="approved" binary="true" inputId="ad_user"
								class="custom-checkbox me-3"></p-checkbox>
							<label for="ad_user">Approve</label>
						</div> -->
                    <!-- <div class=" footer-btn  mt-6"> -->
                    <button pButton label="Submit" type="submit" class="fetch-data-btn"
                        [disabled]="routeForm.invalid"></button>
                    <!-- </div> -->
                </div>


            </form>



            <!-- MAke it table here -->

            <!-- <div class="mt-4  mb-4">
				<ng-container *ngIf="proposalData?.length > 0">
					<app-data-table [columns]="route_cols" [data]="proposalData" title="User to Proposal Mapping"
						[showAddButton]="false" [isDeletable]="true"></app-data-table>
				</ng-container>
			</div> -->

        </div>

    </p-dialog>
    <p-dialog header="PDF View " [(visible)]="displayDialog" position="top" [draggable]="true" [resizable]="true"
        [modal]="true" [style]="{width: '50vw'}" [closable]="true" [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
        [maximizable]="true">
        <div class="p-3 mt-4">
            <div class="d-flex justify-content-between mb-3">
                <p-floatLabel variant="in" class="mt-2"
                    *ngIf="step_details?.is_initiator || step_details?.is_approver || step_details?.is_recommender || (step_details?.step_status != 'approved' && userID == 6)">
                    <input pInputText id="DocName" pSize="large" [(ngModel)]="DocName" autocomplete="off"
                        class="w-100" />
                    <label for="DocName">Document Name with Version </label>
                </p-floatLabel>
                <div class="d-flex gap-16">
                    <button class="btn btn-primary   " (click)="saveVersion()"
                        *ngIf="step_details?.is_initiator || step_details?.is_approver || step_details?.is_recommender || (step_details?.step_status != 'approved' && userID == 6)">Save
                        Version</button>
                    <button class="btn btn-primary" [openNewTab]="true" printSectionId="printSection" ngxPrint
                        styleSheetFile="assets/pdfcss.css">Download PDF</button>
                </div>
            </div>
            <div id="printSection" class="table-bordered">
                <table class="table table-bordered">
                    <tr>
                        <td colspan="2" class="border font-weight-bold p-2">
                            <h4 class="text-center">{{stapName?.name}}</h4>
                        </td>
                    </tr>
                    <tr *ngFor="let item of pdfdata?.data">
                        <ng-container *ngIf="isHTMLorText(item.value)">
                            <td colspan="2" class=" font-weight-bold p-2">
                                <h4>{{ item.key }}</h4>
                                <span [innerHTML]="item.value"></span>
                            </td>
                        </ng-container>
                        <ng-container *ngIf="!isHTMLorText(item.value)">
                            <td class="border font-weight-bold p-2">{{ item.key }}</td>
                            <td class="border p-2">{{ item.value }}</td>
                        </ng-container>
                    </tr>
                </table>
            </div>
        </div>

    </p-dialog>
    <p-dialog header="{{
    IRA === 'Initiate' ? 'Initiator' :
    IRA === 'Recommend' ? 'Recommender' :
    'Approver'
  }}" [(visible)]="isIRA" position="top" [draggable]="true" [resizable]="true" [modal]="true"
        [style]="{ width: '50vw' }" [closable]="true" [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
        [maximizable]="true">
        <div class="card-body mt-3">
            <div class=" mt-3">
                <div class="card-header">
                    <h5 class="mb-0">{{
                        IRA === 'Initiate' ? 'Initiator' :
                        IRA === 'Recommend' ? 'Recommender' :
                        'Approver'
                        }} Remarks</h5>
                </div>
                <p-floatLabel variant="in" class="mt-2 w-100">
                    <textarea pInputTextarea id="DocName" rows="10" [(ngModel)]="IRAremarks" autocomplete="off"
                        class="w-100"></textarea>
                    <!-- <label for="DocName">Comments</label> -->
                </p-floatLabel>
            </div>
            <div *ngIf="step_details.add_route_conf">
                <h5 class="mb-2 mt-2">Add Member to the next route.</h5>
                <form [formGroup]="routeForm" (ngSubmit)="onrouteFormSubmit()">
                    <div class="row">
                        <!-- <div class="col-md-6 mb-3 ">
						<label>Steps</label>
						<p-dropdown [options]="stagesList" formControlName="step" optionValue="id" optionLabel="name"
							[filter]="true" filterBy="name" placeholder="Select a Stage" class="w-100"
							(onChange)="onStepChange($event)">
						</p-dropdown>
					</div> -->
                        <div class="col-md-12 mb-3">
                            <label>Role</label>
                            <p-dropdown [options]="roleList" formControlName="role" optionValue="id" optionLabel="name"
                                [filter]="true" filterBy="name" placeholder="Select a Role" class="w-100"
                                (onChange)="onRoleChange($event)" appendTo="body">
                            </p-dropdown>
                        </div>
                        <!-- <div class="col-md-6 mb-3">
							<label>Directorate</label>
							<p-dropdown [options]="unitList" formControlName="unit" optionValue="id" optionLabel="name"
								placeholder="Select a Directorate" class="w-100" (onChange)="onUnitChange($event)"
								[filter]="true" filterBy="name" appendTo="body">
							</p-dropdown>
						</div> -->
                        <div class="col-md-12 mb-3">
                            <label>User</label>
                            <p-dropdown [options]="userList" formControlName="user" optionValue="id"
                                optionLabel="first_name" placeholder="Select a User" class="w-100" [filter]="true"
                                filterBy="first_name" appendTo="body" (onChange)="onUserChange($event)">
                                <ng-template let-user pTemplate="item">
                                    <div class="list-group-item list-group-item-action">
                                        <small> {{ user.unit.name }} - {{ user.hrcdf_designation }} {{ user.first_name
                                            }} {{ user.last_name }} - {{ user.loginname }}</small>
                                    </div>
                                </ng-template>
                            </p-dropdown>
                        </div>
                        <!-- <div class="col-md-6 mb-3 flex-col">
						<label for="menuIcon">Sequence</label>
						<input id="menuIcon" type="text" pInputText formControlName="level" placeholder="Enter Sequence"
							class="w-100" />
					</div> -->
                        <div class="col-md-12 mb-3 d-flex justify-content-end">
                            <!-- <div class=" mb-3 ad-user">
							<p-checkbox formControlName="approved" binary="true" inputId="ad_user"
								class="custom-checkbox me-3"></p-checkbox>
							<label for="ad_user">Approve</label>
						</div> -->
                            <!-- <div class=" footer-btn  mt-6">
								<button pButton label="Submit" type="submit" class="fetch-data-btn"></button>
							</div> -->
                        </div>

                    </div>
                </form>
            </div>

            <div class="card-footer text-end gap-3">
                <button pButton label="Reject" *ngIf="IRA !== 'Initiate'" type="submit" icon="pi pi-times"
                    class="p-button-danger me-4  reject-btn" (click)="submitIRA(false)"></button>
                <button pButton label="{{ IRA }} and Send" type="submit" icon="pi pi-check"
                    class="p-button-success initiate-btn" (click)="submitIRA(true);"
                    *ngIf="step_details.add_route_conf"></button>
                <button pButton label="{{ IRA }}" type="submit" icon="pi pi-check" class="p-button-success initiate-btn"
                    (click)="submitIRA(true)" *ngIf="!step_details.add_route_conf"></button>
            </div>
        </div>
    </p-dialog>

    <p-dialog header="'Route Config'" [(visible)]="opennewRouteDialog" [draggable]="true" [resizable]="true"
        [modal]="true" [style]="{ width: '50vw' }" [closable]="true"
        [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }" [maximizable]="true">
        <form [formGroup]="routeFormNew">
            <div class="row">
                <h5>Select user to the next level</h5>

                <!-- ADDED USERS HORIZONTAL DISPLAY -->
                <div *ngIf="addedUsers.length > 0" class="mb-3 d-flex align-items-center overflow-auto user-flow-row"
                    style="white-space: nowrap; max-width: 100%; padding-bottom: 10px;">
                    <ng-container *ngFor="let user of addedUsers; let i = index">

                        <!-- User Box Container -->
                        <div class="position-relative me-2">
                            <!-- Box -->
                            <div
                                class="user-box-horizontal px-3 py-2 rounded border bg-light text-center position-relative">
                                {{ user.first_name }} {{ user.last_name }}

                                <!-- ❌ Remove icon on far right edge -->
                                <i class="pi pi-times remove-user-btn" (click)="removeUser(user)"
                                    style="cursor: pointer;" title="Remove user"></i>
                            </div>
                        </div>

                        <!-- Connector line (except after last item) -->
                        <div *ngIf="i < addedUsers.length - 1" class="horizontal-connector me-2"></div>
                    </ng-container>
                </div>


                <!-- 👇 Dropdown and buttons -->
                <div class="col-md-6 mb-3">
                    <label>Role</label>
                    <p-dropdown [options]="roleList" formControlName="role" optionValue="id" optionLabel="name"
                        [filter]="true" filterBy="name" placeholder="Select a Role" class="w-100"
                        (onChange)="onRoleChange($event)" appendTo="body">
                    </p-dropdown>
                </div>
                <div class="mb-3 d-flex col-md-6 flex-col">
                    <label>Search and Select a user</label>
                    <!-- <p-dropdown [options]="userList" formControlName="user" optionValue="id" optionLabel="first_name"
                        placeholder="Select a User" class="w-100" [filter]="true" (onChange)="onUserChange($event)"
                        appendTo="body" (onFilter)="onFilter($event)">
                        <ng-template let-user pTemplate="item">
                            <div class="list-group-item list-group-item-action">
                                {{ user.unit.name }} - {{ user.hrcdf_designation }} {{ user.first_name }} {{
                                user.last_name }} - <small>{{ user.loginname }}</small>
                            </div>
                        </ng-template>
                    </p-dropdown> -->

                    <p-autoComplete [(ngModel)]="selectedItem" [suggestions]="filteredUserList"
                        (completeMethod)="onFilter($event)" field="first_name" placeholder="Search User" [minLength]="3"
                        [forceSelection]="true" class="w-100 col-md-6">

                        <ng-template let-user pTemplate="item">
                            <div class="list-group-item list-group-item-action">
                                {{ user.unit.name }} - {{ user.hrcdf_designation }} {{ user.first_name }} {{
                                user.last_name }} - <small>{{
                                    user.loginname }}</small>
                            </div>
                        </ng-template>
                    </p-autoComplete>


                </div>

                <!-- Buttons -->
                <div class="col-md-12 mb-3 d-flex justify-content-end gap-3">

                    <!-- <div class="footer-btn mt-2"> -->
                    <button class="fetch-data-btn" (click)="addSelectedUser()"> Add User </button>

                    <!-- </div>
                    <div class="footer-btn mt-2"> -->

                    <button pButton label="Submit" type="submit" class="fetch-data-btn"
                        (click)="routeformModal()"></button>
                    <!-- </div> -->
                </div>
            </div>
        </form>
    </p-dialog>
<p-dialog header="Share Proposal" [(visible)]="displayDialogN" [modal]="true" [draggable]="false" [resizable]="false"
  [style]="{width: '65vw'}" appendTo="body" contentStyle="overflow: visible">
  <div class="p-fluid">
    <!-- Share Type Selection -->
    <div class=" mb-4 mt-3">
      <div class="row d-flex align-items-center justify-content-between">
        <div class="col-4 bg-primary text-white d-flex align-items-center justify-content-start p-3">Share With:</div>
        <div class="col-8 d-flex align-items-center ps-5">
          <div class="col-6 d-flex align-items-center gap-2">
            <p-radioButton name="shareType" value="internal" [(ngModel)]="shareType" class="d-block"></p-radioButton>
            <span>Internal</span>
          </div>
          <div class="col-6 d-flex align-items-center gap-2">
            <p-radioButton name="shareType" value="external" [(ngModel)]="shareType" class="d-block"></p-radioButton>
            <span>External</span>
          </div>
        </div>
      </div>
    </div>
    <!-- Permission Type Selection -->
    <div class=" mb-4" *ngIf="shareType">
      <div class="row d-flex align-items-center justify-content-between">
        <div class="col-4 bg-primary text-white d-flex align-items-center justify-content-start p-3">Permission Type:
        </div>
        <div class="col-8 d-flex align-items-center ps-5">
          <div class="col-4 d-flex align-items-center gap-2">
            <p-radioButton name="permission" value="edit" [(ngModel)]="permissionType" class="d-block"></p-radioButton>
            <span>Edit</span>
          </div>
          <div class="col-4 d-flex align-items-center gap-2">
            <p-radioButton name="permission" value="view" [(ngModel)]="permissionType" class="d-block"></p-radioButton>
            <span>View</span>
          </div>
          <div class="col-4 d-flex align-items-center gap-2">
            <p-radioButton name="permission" value="comment" [(ngModel)]="permissionType"
              class="d-block"></p-radioButton>
            <span>Comment</span>
          </div>
        </div>
      </div>
    </div>
    <!-- Internal Section -->
    <div *ngIf="shareType === 'internal' && permissionType" class="row mb-4">
      <div class="col-12">
        <div class="row">
          <!-- User Selection -->
          <div class="col-12">
            <div class="row">
              <div class="col-4 bg-primary text-white d-flex align-items-center">
                <b class="mb-2 d-block">
                  {{ permissionType === 'edit' ? 'Select User' : 'Select Users' }}
                </b>
              </div>
              <div class="col-8">
                <!-- Single selection for Edit permission -->
                <p-dropdown *ngIf="permissionType === 'edit'" id="userSelect" [options]="userListN"
                  optionLabel="first_name" filter="true" [(ngModel)]="selectedUserN" placeholder="Choose a user"
                  appendTo="body" class="w-100">
                  <ng-template let-user pTemplate="item">
                    <div class="list-group-item list-group-item-action">
                      <small>{{user.hrcdf_designation}} {{ user.first_name }} {{ user.last_name }} - {{ user.loginname
                        }}</small>
                    </div>
                  </ng-template>
                </p-dropdown>
                <!-- Multi selection for View/Comment permissions -->
                <p-multiSelect *ngIf="permissionType !== 'edit'" [options]="userListN" optionLabel="first_name"
                  filter="true" [(ngModel)]="selectedUserN" placeholder="Choose users" appendTo="body" class="w-100">
                  <ng-template let-user pTemplate="item">
                    <div class="list-group-item list-group-item-action">
                      <small>{{user.hrcdf_designation}} {{ user.first_name }} {{ user.last_name }} - {{ user.loginname
                        }}</small>
                    </div>
                  </ng-template>
                </p-multiSelect>
              </div>
            </div>
          </div>
        </div>
        <!-- Comment Section -->
        <div class="row mt-3">
          <div class="col-4 bg-primary text-white d-flex align-items-center">
            <b class="mb-2 d-block">Comment (optional)</b>
          </div>
          <div class="col-8">
            <textarea id="internalComment" class="form-control w-100" rows="3" [(ngModel)]="internalComment"
              placeholder="Enter your comment here..."></textarea>
          </div>
        </div>
      </div>
    </div>

    <!-- External Section -->
    <div *ngIf="shareType === 'external' && permissionType" class="row mb-4">
      <div class="col-12">
        <div class="row">
          <!-- Unit Selection -->
          <div class="col-12">
            <div class="row mb-3">
              <div class="col-4 bg-primary text-white d-flex align-items-center">
                <b class="mb-2 d-block">
                  {{ permissionType === 'edit' ? 'Select Unit' : 'Select Units' }}
                </b>
              </div>
              <div class="col-8">
                <!-- Single selection for Edit permission -->
                <p-dropdown *ngIf="permissionType === 'edit'" id="unitSelect" [options]="unitListN" optionLabel="name"
                  [(ngModel)]="selectedUnit" placeholder="Choose a unit" appendTo="body" class="w-100">
                </p-dropdown>

                <!-- Multi selection for View/Comment permissions -->
                <p-multiSelect *ngIf="permissionType !== 'edit'" [options]="unitListN" optionLabel="name"
                  [(ngModel)]="selectedUnit" placeholder="Choose units" appendTo="body" class="w-100">
                </p-multiSelect>
              </div>
            </div>
          </div>
        </div>

        <!-- Comment Section -->
        <div class="row">
          <div class="col-4 bg-primary text-white d-flex align-items-center">
            <b class="mb-2 d-block">Comment (optional)</b>
          </div>
          <div class="col-8">
            <textarea id="externalComment" class="form-control w-100" rows="3" [(ngModel)]="externalComment"
              placeholder="Enter your comment here..."></textarea>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Footer -->
  <!-- <ng-template pTemplate="footer">
    <button (click)="saveSelection()" class="fetch-data-btn p-button p-button-sm p-button-primary"
      [disabled]="!isFormValid()">
      Save
    </button>
  </ng-template> -->
    <ng-template pTemplate="footer">
        <button (click)="saveSelection()" class="fetch-data-btn p-button p-button-sm p-button-primary"> Save
        </button>
    </ng-template>
</p-dialog>

    <!-- <p-dialog header="Share Proposal" [(visible)]="displayDialogN" [modal]="true" [draggable]="false"
		[resizable]="false" [style]="{width: '65vw'}" appendTo="body" contentStyle="overflow: visible">
		<div class="p-fluid">
			<div class="mb-4 mt-3">
				<h6 class="mb-2">Share With:</h6>
				<div class="d-flex gap-4 align-items-center">
					<p-radioButton name="shareType" value="internal" label="Internal"
						[(ngModel)]="shareType"></p-radioButton>
					<p-radioButton name="shareType" value="external" label="External"
						[(ngModel)]="shareType"></p-radioButton>
				</div>
			</div>

			<div *ngIf="shareType === 'internal'" class="mb-4">
				<div class="d-flex gap-4 flex-wrap align-items-start">

					<div class="flex-grow-1">
						<label for="userSelect" class="mb-2 d-block">Select User</label>
						<p-dropdown id="userSelect" [options]="userListN" optionLabel="first_name" filter="true"
							filterby="" [(ngModel)]="selectedUserN" placeholder="Choose a user" appendTo="body"
							class="w-100">
							<ng-template let-user pTemplate="item">
								<div class="list-group-item list-group-item-action col-md-6">
									<small> {{user.hrcdf_designation}} {{ user.first_name }} {{ user.last_name }} - {{
										user.loginname }}</small>
								</div>
							</ng-template>
						</p-dropdown>
					</div>

					<div class="flex-grow-1">
						<label class="mb-2 d-block">Permission Type</label>
						<div class="d-flex gap-3 flex-wrap">
							<p-radioButton name="permission" value="edit" label="Edit"
								[(ngModel)]="permissionType"></p-radioButton>
							<p-radioButton name="permission" value="view" label="View"
								[(ngModel)]="permissionType"></p-radioButton>
							<p-radioButton name="permission" value="comment" label="Comment"
								[(ngModel)]="permissionType"></p-radioButton>
						</div>
					</div>
				</div>

				<div class="mt-3">
					<label for="internalComment" class="mb-2 d-block">Comment (optional)</label>
					<textarea id="internalComment" class="form-control w-100" rows="3" [(ngModel)]="internalComment"
						placeholder="Enter your comment here..."></textarea>
				</div>
			</div>

			<div *ngIf="shareType === 'external'" class="mb-4">
				<div class="mb-3">
					<label for="unitSelect" class="mb-2 d-block">Select Unit</label>
					<p-dropdown id="unitSelect" [options]="unitListN" optionLabel="name" [(ngModel)]="selectedUnit"
						placeholder="Choose a unit" appendTo="body" class="w-100">
					</p-dropdown>
				</div>

				<div>
					<label for="externalComment" class="mb-2 d-block">Comment (optional)</label>
					<textarea id="externalComment" class="form-control w-100" rows="3" [(ngModel)]="externalComment"
						placeholder="Enter your comment here..."></textarea>
				</div>
			</div>
		</div>

		<ng-template pTemplate="footer">
			<button (click)="saveSelection()" class="fetch-data-btn p-button p-button-sm p-button-primary"> Save
			</button>
		</ng-template>
	</p-dialog> -->